export default __webpack_public_path__ + "static/media/FROYO-3Pool.2b9442fb.png";